import { module } from 'modujs'
import { ENV } from '../config'

export default class extends module {
  init() {
    this.bgsList = this.el.querySelector('.c-solutions_backgrounds_inner')
    this.bgsListItems = [...this.el.querySelectorAll('.c-solutions_backgrounds_item')]
    this.items = [...this.el.querySelectorAll('.c-solutions_list_item')]
    this.nbItems = this.items.length
    this.descriptions = this.el.querySelector('.c-solutions_descriptions')
    this.descriptionList = [...this.el.querySelectorAll('.c-solutions_description')]

    if (ENV.IS_TOUCH) {
      this.currentIndex = 0
      this.interval = setInterval(() => {
        this.currentIndex = (this.currentIndex === this.nbItems - 1)
          ? 0
          : this.currentIndex + 1
        this.bgsList.style.transform = `translate3D(-${(this.currentIndex / (this.nbItems)) * 100}%, 0, 0)`

        if (this.el.querySelector('.c-solutions_list_item.-active')) {
          this.el.querySelector('.c-solutions_list_item.-active').classList.remove('-active')
        }
        this.items[this.currentIndex].classList.add('-active')

        if (this.descriptions.querySelector('.-active')) {
          this.descriptions.querySelector('.-active').classList.remove('-active')
        }
        this.descriptionList[this.currentIndex].classList.add('-active')
      }, 4000)
    }
    else {
      this.items.forEach((elt, index) => {
        elt.$mouseEnterCallback = () => {
          this.bgsList.style.transform = `translate3D(-${(index / (this.nbItems)) * 100}%, 0, 0)`

          if (this.descriptions.querySelector('.-active')) {
            this.descriptions.querySelector('.-active').classList.remove('-active')
          }
          this.descriptionList[index].classList.add('-active')
        }

        elt.addEventListener('mouseenter', elt.$mouseEnterCallback)
      })
    }

    if (!ENV.IS_SM) {
      if (this.el.querySelectorAll('.c-solutions_backgrounds_item_canvas')) {
        this.el.querySelectorAll('.c-solutions_backgrounds_item_canvas').forEach((canvas) => {
          const video = canvas.closest('.c-media').querySelector('video')

          this.initValeursBg(video, canvas)
        })
      }
    }
  }

  toggleVideos(e) {
    if (e.way === 'enter') {
      this.bgsListItems.forEach((elt) => {
        if (elt.querySelector('video')) {
          elt.querySelector('video').play()
        }
      })
    }
    else {
      this.bgsListItems.forEach((elt) => {
        if (elt.querySelector('video')) {
          elt.querySelector('video').pause()
        }
      })
    }
  }

  initValeursBg(vid, canvas) {
    const ctx = canvas.getContext('2d')
    // vid.play();

    let vidWidth
    let vidHeight
    const that = this

    if (!vid.classList.contains('loaded')) {
      const req = new XMLHttpRequest()

      req.open(
        'GET',
        vid.getAttribute('src'),
        true
      )
      req.responseType = 'blob'

      req.onload = function () {
        if (this.status === 200 || this.status === 206) {
          const videoBlob = this.response
          const v = URL.createObjectURL(videoBlob) // IE10+

          vid.src = v
          vid.classList.add('loaded')
        }
      }
      req.onerror = function () {}

      req.send()
    }

    vid.onloadedmetadata = function () {
      vid.classList.add('loaded')
      vidWidth = vid.videoWidth
      vidHeight = vid.videoHeight

      canvas.width = vid.offsetWidth
      canvas.height = vid.offsetHeight

      drawingLoop()

      setTimeout(() => {
        setVideoBgColor(vid)
        // vid.pause();
      }, 200)
    }

    function drawingLoop() {
      that.requestId = window.requestAnimationFrame(drawingLoop)

      ctx.drawImage(
        vid,
        0,
        0,
        vidWidth,
        vidHeight, // source rectangle
        0,
        0,
        canvas.width,
        canvas.height
      ) // destination rectangle);
    }

    function setVideoBgColor(vid) {
      // draw first four pixel of video to a canvas
      // then get pixel color from that canvas
      const canvas = document.createElement('canvas')

      canvas.width = 8
      canvas.height = 8

      const ctx = canvas.getContext('2d')

      ctx.drawImage(
        vid,
        0,
        0,
        8,
        8
      )

      const p = ctx.getImageData(
        0,
        0,
        8,
        8
      ).data

      // dont take the first but fourth pixel [r g b]
      that.el.style.backgroundColor = `rgb(${p[60]},${p[61]},${p[62]})`
    }

    this.onResize = () => {
      vidWidth = vid.videoWidth
      vidHeight = vid.videoHeight

      canvas.width = vid.offsetWidth
      canvas.height = vid.offsetHeight

      // redraw canvas after resize
      ctx.drawImage(
        vid,
        0,
        0,
        vidWidth,
        vidHeight, // source rectangle
        0,
        0,
        canvas.width,
        canvas.height
      ) // destination rectangle);
    }

    window.addEventListener('resize', this.onResize)
  }

  destroy() {
    cancelAnimationFrame(this.requestId)

    if (this.interval !== undefined)
      clearInterval(this.interval)

    if (this.onResize)
      window.removeEventListener('resize', this.onResize)

    this.items.forEach((elt) => {
      if (elt.$mouseEnterCallback) {
        elt.removeEventListener('mouseenter', elt.$mouseEnterCallback)
        elt.$mouseEnterCallback = undefined
      }
    })
  }
}
